import { z } from "zod";
import { ErrorCode } from "@bliks-io/contracts";
// Required, non-whitespace string — the start-event fields' historical rule.
const requiredTrimmed = z.string().min(1, ErrorCode.FIELD_REQUIRED).refine((val)=>val.trim().length > 0, {
    message: ErrorCode.FIELD_REQUIRED
});
export const InputFormDataSchema = z.discriminatedUnion("inputType", [
    z.object({
        inputType: z.literal("event"),
        type: requiredTrimmed,
        name: requiredTrimmed,
        description: requiredTrimmed
    }),
    z.object({
        inputType: z.literal("previous_output"),
        name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
        description: z.string().min(1, ErrorCode.FIELD_REQUIRED),
        sourceSteps: z.array(z.object({
            stepId: z.string(),
            ruleIds: z.array(z.string()).optional()
        })).optional()
    })
]);
export function toStepInput(formData) {
    if (formData.inputType === "event") {
        return {
            inputType: "event",
            type: formData.type,
            name: formData.name,
            description: formData.description
        };
    }
    return {
        inputType: "previous_output",
        name: formData.name,
        description: formData.description,
        ...formData.sourceSteps?.length && {
            sourceSteps: formData.sourceSteps
        }
    };
}
export function toStartEventContent(formData) {
    if (formData.inputType === "event") {
        return {
            eventType: formData.type,
            name: formData.name,
            description: formData.description
        };
    }
    throw new Error("Cannot convert previous_output to StartEventContent");
}
export function fromStartEventContent(event) {
    return {
        inputType: "event",
        type: event.eventType,
        name: event.name,
        description: event.description
    };
}

//# sourceMappingURL=inputFormSchema.js.map